import { Component, OnInit } from '@angular/core';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private loginService: LoginService
  ) { 
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit() {
  }

}
